import React, { useState, useEffect } from "react";
import { API_ENDPOINTS } from "../config";
import logo from "../assets/lna.png";
import backgroundImage from "../assets/reg.jpg";

const AddMember = () => {
  const [formData, setFormData] = useState({
    title: "",
    name: "",
    email: "",
    gender: "",
    marital_status: "",
    id_number: "",
    employment_number: "",
    grade: "",
    phone_number: "",
    nationality: "",
    date_of_birth: "",
    employer_name: "",
    duty_station: "",
    district: "",
    type_of_employment: "",
    qualifications: [""],
    year_obtained: [""],
    next_of_kin_full_name: "",
    next_of_kin_address: "",
    next_of_kin_contact: "",
    next_of_kin_relationship: "",
    payment_frequency: "",
    payment_method: "",
    approved_at: null,
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Handle dynamic qualification fields
  const handleQualificationChange = (index, field, value) => {
    const updatedArray = [...formData[field]];
    updatedArray[index] = value;
    setFormData({ ...formData, [field]: updatedArray });
  };

  const addQualificationField = () => {
    setFormData({
      ...formData,
      qualifications: [...formData.qualifications, ""],
      year_obtained: [...formData.year_obtained, ""],
    });
  };

  const removeQualificationField = (index) => {
    if (formData.qualifications.length > 1) {
      const updatedQualifications = formData.qualifications.filter((_, i) => i !== index);
      const updatedYears = formData.year_obtained.filter((_, i) => i !== index);
      setFormData({
        ...formData,
        qualifications: updatedQualifications,
        year_obtained: updatedYears,
      });
    }
  };

  // Submit form
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const qualifications = formData.qualifications.filter((q) => q.trim() !== "");
    const year_obtained = formData.year_obtained.filter((y) => y.trim() !== "");

    const payload = {
      title: formData.title || "",
      name: formData.name || "",
      email: formData.email || "",
      gender: formData.gender || "",
      marital_status: formData.marital_status || "",
      id_number: formData.id_number || "",
      employment_number: formData.employment_number || "",
      grade: formData.grade || "",
      phone_number: formData.phone_number || "",
      nationality: formData.nationality || "",
      date_of_birth: formData.date_of_birth || null,
      employer_name: formData.employer_name || "",
      duty_station: formData.duty_station || "",
      district: formData.district || "",
      type_of_employment: formData.type_of_employment || "",
      qualifications: JSON.stringify(qualifications),
      year_obtained: JSON.stringify(year_obtained),
      next_of_kin_full_name: formData.next_of_kin_full_name || "",
      next_of_kin_address: formData.next_of_kin_address || "",
      next_of_kin_contact: formData.next_of_kin_contact || "",
      next_of_kin_relationship: formData.next_of_kin_relationship || "",
      payment_frequency: formData.payment_frequency || "",
      payment_method: formData.payment_method || "",
      approved_at: null,
    };

    try {
      const response = await fetch(API_ENDPOINTS.ADD_MEMBER, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (response.ok) {
        alert(`Thank you, ${formData.name}, for registering!`);
        setFormData({
          title: "",
          name: "",
          email: "",
          gender: "",
          marital_status: "",
          id_number: "",
          employment_number: "",
          grade: "",
          phone_number: "",
          nationality: "",
          date_of_birth: "",
          employer_name: "",
          duty_station: "",
          district: "",
          type_of_employment: "",
          qualifications: [""],
          year_obtained: [""],
          next_of_kin_full_name: "",
          next_of_kin_address: "",
          next_of_kin_contact: "",
          next_of_kin_relationship: "",
          payment_frequency: "",
          payment_method: "",
          approved_at: null,
        });
      } else {
        alert("Registration failed: " + result.message);
        console.error(result.error);
      }
    } catch (err) {
      alert("Failed to submit form.");
      console.error(err);
    } finally {
      setIsSubmitting(false);
    }
  };

  // Add CSS styles to head
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
      
      @media (min-width: 768px) {
        .form-grid-responsive {
          grid-template-columns: repeat(2, 1fr) !important;
        }
        .qualification-inputs-responsive {
          grid-template-columns: 2fr 1fr !important;
        }
        .qualification-row-responsive {
          flex-direction: row !important;
          align-items: flex-end !important;
        }
      }

      @media (min-width: 1024px) {
        .form-grid-responsive {
          grid-template-columns: repeat(3, 1fr) !important;
        }
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <div style={styles.container}>
      <div style={styles.backgroundOverlay}>
        <div style={styles.contentWrapper}>
          {/* Header Section */}
          <div style={styles.headerSection}>
            <img src={logo} alt="LNA Logo" style={styles.logo} />
            <h1 style={styles.header}>Member Registration</h1>
            <p style={styles.subtitle}>Join the Lesotho Nursing And Midwifery Organization</p>
          </div>

          {/* Form Section */}
          <form onSubmit={handleSubmit} style={styles.form}>
            {/* Personal Information Section */}
            <div style={styles.section}>
              <h3 style={styles.sectionTitle}>
                <span style={styles.sectionIcon}>👤</span>
                Personal Information
              </h3>
              <div style={{...styles.formGrid, ...styles.formGridResponsive}}>
                <div style={styles.inputGroup}>
                  <label style={styles.label}>Title *</label>
                  <select name="title" value={formData.title} onChange={handleChange} required style={styles.input}>
                    <option value="">Select Title</option>
                    <option value="Mr">Mr</option>
                    <option value="Mrs">Mrs</option>
                    <option value="Miss">Miss</option>
                    <option value="Dr">Dr</option>
                  </select>
                </div>

                <div style={styles.inputGroup}>
                  <label style={styles.label}>Gender *</label>
                  <select name="gender" value={formData.gender} onChange={handleChange} required style={styles.input}>
                    <option value="">Select Gender</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                  </select>
                </div>

                <div style={styles.inputGroup}>
                  <label style={styles.label}>Marital Status *</label>
                  <select name="marital_status" value={formData.marital_status} onChange={handleChange} required style={styles.input}>
                    <option value="">Select Marital Status</option>
                    <option value="Single">Single</option>
                    <option value="Married">Married</option>
                    <option value="Widowed">Widowed</option>
                    <option value="Divorced">Divorced</option>
                  </select>
                </div>

                <div style={styles.inputGroup}>
                  <label style={styles.label}>Full Name *</label>
                  <input type="text" name="name" placeholder="Enter full name" value={formData.name} onChange={handleChange} required style={styles.input} />
                </div>

                <div style={styles.inputGroup}>
                  <label style={styles.label}>ID Number *</label>
                  <input type="text" name="id_number" placeholder="Enter ID number" value={formData.id_number} onChange={handleChange} required style={styles.input} />
                </div>

                <div style={styles.inputGroup}>
                  <label style={styles.label}>Employment Number *</label>
                  <input type="text" name="employment_number" placeholder="Enter employment number" value={formData.employment_number} onChange={handleChange} required style={styles.input} />
                </div>

                <div style={styles.inputGroup}>
                  <label style={styles.label}>Grade *</label>
                  <input type="text" name="grade" placeholder="Enter grade" value={formData.grade} onChange={handleChange} required style={styles.input} />
                </div>

                <div style={styles.inputGroup}>
                  <label style={styles.label}>Email *</label>
                  <input type="email" name="email" placeholder="Enter email address" value={formData.email} onChange={handleChange} required style={styles.input} />
                </div>

                <div style={styles.inputGroup}>
                  <label style={styles.label}>Phone Number *</label>
                  <input type="text" name="phone_number" placeholder="Enter phone number" value={formData.phone_number} onChange={handleChange} required style={styles.input} />
                </div>

                <div style={styles.inputGroup}>
                  <label style={styles.label}>Nationality *</label>
                  <input type="text" name="nationality" placeholder="Enter nationality" value={formData.nationality} onChange={handleChange} required style={styles.input} />
                </div>

                <div style={styles.inputGroup}>
                  <label style={styles.label}>Date of Birth</label>
                  <input type="date" name="date_of_birth" value={formData.date_of_birth} onChange={handleChange} style={styles.input} />
                </div>
              </div>
            </div>

            {/* Employment Information Section */}
            <div style={styles.section}>
              <h3 style={styles.sectionTitle}>
                <span style={styles.sectionIcon}>💼</span>
                Employment Information
              </h3>
              <div style={{...styles.formGrid, ...styles.formGridResponsive}}>
                <div style={styles.inputGroup}>
                  <label style={styles.label}>Employer Name *</label>
                  <input type="text" name="employer_name" placeholder="Enter employer name" value={formData.employer_name} onChange={handleChange} required style={styles.input} />
                </div>

                <div style={styles.inputGroup}>
                  <label style={styles.label}>Duty Station *</label>
                  <input type="text" name="duty_station" placeholder="Enter duty station" value={formData.duty_station} onChange={handleChange} required style={styles.input} />
                </div>

                <div style={styles.inputGroup}>
                  <label style={styles.label}>District *</label>
                  <input type="text" name="district" placeholder="Enter district" value={formData.district} onChange={handleChange} required style={styles.input} />
                </div>

                <div style={styles.inputGroup}>
                  <label style={styles.label}>Type of Employment *</label>
                  <select name="type_of_employment" value={formData.type_of_employment} onChange={handleChange} required style={styles.input}>
                    <option value="">Select employment type</option>
                    <option value="Permanent and pensionable">Permanent and Pensionable</option>
                    <option value="Contract">Contract</option>
                  </select>
                </div>
              </div>
            </div>

            {/* Qualifications Section */}
            <div style={styles.section}>
              <h3 style={styles.sectionTitle}>
                <span style={styles.sectionIcon}>🎓</span>
                Qualifications
              </h3>
              {formData.qualifications.map((q, index) => (
                <div key={index} style={{...styles.qualificationRow, ...styles.qualificationRowResponsive}}>
                  <div style={{...styles.qualificationInputs, ...styles.qualificationInputsResponsive}}>
                    <div style={styles.inputGroup}>
                      <label style={styles.label}>Qualification {index + 1}</label>
                      <input
                        type="text"
                        placeholder="Enter qualification"
                        value={formData.qualifications[index]}
                        onChange={(e) => handleQualificationChange(index, "qualifications", e.target.value)}
                        style={styles.input}
                      />
                    </div>
                    <div style={styles.inputGroup}>
                      <label style={styles.label}>Year Obtained</label>
                      <input
                        type="text"
                        placeholder="Enter year"
                        value={formData.year_obtained[index]}
                        onChange={(e) => handleQualificationChange(index, "year_obtained", e.target.value)}
                        style={styles.input}
                      />
                    </div>
                  </div>
                  {formData.qualifications.length > 1 && (
                    <button 
                      type="button" 
                      onClick={() => removeQualificationField(index)} 
                      style={styles.removeButton}
                    >
                      ✕
                    </button>
                  )}
                </div>
              ))}
              <button type="button" onClick={addQualificationField} style={styles.addButton}>
                + Add Another Qualification
              </button>
            </div>

            {/* Next of Kin Section */}
            <div style={styles.section}>
              <h3 style={styles.sectionTitle}>
                <span style={styles.sectionIcon}>👨‍👩‍👧‍👦</span>
                Next of Kin Information
              </h3>
              <div style={{...styles.formGrid, ...styles.formGridResponsive}}>
                <div style={styles.inputGroup}>
                  <label style={styles.label}>Full Name *</label>
                  <input type="text" name="next_of_kin_full_name" placeholder="Enter full name" value={formData.next_of_kin_full_name} onChange={handleChange} required style={styles.input} />
                </div>

                <div style={styles.inputGroup}>
                  <label style={styles.label}>Address *</label>
                  <input type="text" name="next_of_kin_address" placeholder="Enter address" value={formData.next_of_kin_address} onChange={handleChange} required style={styles.input} />
                </div>

                <div style={styles.inputGroup}>
                  <label style={styles.label}>Contact *</label>
                  <input type="text" name="next_of_kin_contact" placeholder="Enter contact number" value={formData.next_of_kin_contact} onChange={handleChange} required style={styles.input} />
                </div>

                <div style={styles.inputGroup}>
                  <label style={styles.label}>Relationship *</label>
                  <input type="text" name="next_of_kin_relationship" placeholder="Enter relationship" value={formData.next_of_kin_relationship} onChange={handleChange} required style={styles.input} />
                </div>
              </div>
            </div>

            {/* Payment Information Section */}
            <div style={styles.section}>
              <h3 style={styles.sectionTitle}>
                <span style={styles.sectionIcon}>💳</span>
                Payment Information
              </h3>
              <div style={{...styles.formGrid, ...styles.formGridResponsive}}>
                <div style={styles.inputGroup}>
                  <label style={styles.label}>Payment Frequency</label>
                  <select name="payment_frequency" value={formData.payment_frequency} onChange={handleChange} style={styles.input}>
                    <option value="">Select payment frequency</option>
                    <option value="Monthly">Monthly - M50</option>
                    <option value="Annual">Annual - M600</option>
                  </select>
                </div>

                <div style={styles.inputGroup}>
                  <label style={styles.label}>Payment Method</label>
                  <select name="payment_method" value={formData.payment_method} onChange={handleChange} style={styles.input}>
                    <option value="">Select payment method</option>
                    <option value="Automatic salary deduction">Automatic salary deduction</option>
                    <option value="Monthly debit order">Monthly debit order</option>
                    <option value="Annual Lumpsum">Annual Lumpsum</option>
                  </select>
                </div>
              </div>
            </div>

            {/* Submit Button */}
            <div style={styles.submitSection}>
              <button type="submit" disabled={isSubmitting} style={isSubmitting ? styles.submitButtonDisabled : styles.submitButton}>
                {isSubmitting ? (
                  <>
                    <span style={styles.spinner}></span>
                    Processing...
                  </>
                ) : (
                  "Complete Registration"
                )}
              </button>
              <p style={styles.requiredNote}>* Required fields</p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: { 
    minHeight: "100vh",
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundAttachment: "fixed",
  },
  backgroundOverlay: {
    minHeight: "100vh",
    backgroundColor: "rgba(255, 255, 255, 0.92)",
    backdropFilter: "blur(2px)",
  },
  contentWrapper: {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "15px",
  },
  headerSection: {
    textAlign: "center",
    marginBottom: "20px",
    padding: "15px 0",
  },
  logo: { 
    width: "80px", 
    height: "80px",
    objectFit: "contain",
    margin: "0 auto 10px auto",
    borderRadius: "50%",
    border: "2px solid #014c75",
    padding: "3px",
    backgroundColor: "white",
  },
  header: { 
    fontSize: "1.8rem",
    fontWeight: "700",
    color: "#014c75",
    marginBottom: "8px",
    textShadow: "0 1px 2px rgba(0,0,0,0.1)",
    lineHeight: "1.2",
  },
  subtitle: {
    fontSize: "0.9rem",
    color: "#666",
    margin: 0,
    lineHeight: "1.4",
  },
  form: {
    backgroundColor: "white",
    borderRadius: "12px",
    padding: "20px",
    boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
    border: "1px solid #e1e5e9",
  },
  section: {
    marginBottom: "30px",
    paddingBottom: "20px",
    borderBottom: "1px solid #e1e5e9",
  },
  sectionTitle: {
    fontSize: "1.1rem",
    fontWeight: "600",
    color: "#014c75",
    marginBottom: "20px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  sectionIcon: {
    fontSize: "1rem",
  },
  // Base mobile styles (single column)
  formGrid: {
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: "15px",
  },
  // Responsive classes that will be overridden by media queries
  formGridResponsive: {
    className: "form-grid-responsive"
  },
  qualificationInputsResponsive: {
    className: "qualification-inputs-responsive"
  },
  qualificationRowResponsive: {
    className: "qualification-row-responsive"
  },
  inputGroup: {
    display: "flex",
    flexDirection: "column",
  },
  label: {
    fontSize: "0.85rem",
    fontWeight: "600",
    color: "#333",
    marginBottom: "6px",
    marginLeft: "2px",
  },
  input: {
    padding: "12px",
    borderRadius: "8px",
    border: "1.5px solid #e1e5e9",
    fontSize: "16px",
    transition: "all 0.3s ease",
    backgroundColor: "#fafbfc",
    minHeight: "48px",
    boxSizing: "border-box",
    width: "100%",
  },
  qualificationRow: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    marginBottom: "15px",
    padding: "15px",
    backgroundColor: "#f8f9fa",
    borderRadius: "8px",
    border: "1px solid #e9ecef",
  },
  qualificationInputs: {
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: "12px",
    width: "100%",
  },
  addButton: {
    padding: "14px 16px",
    border: "2px dashed #014c75",
    backgroundColor: "transparent",
    color: "#014c75",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "0.9rem",
    fontWeight: "600",
    transition: "all 0.3s ease",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "6px",
    width: "100%",
  },
  removeButton: {
    padding: "12px",
    border: "none",
    backgroundColor: "#e74c3c",
    color: "white",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "0.85rem",
    fontWeight: "bold",
    transition: "all 0.3s ease",
    height: "44px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
  },
  submitSection: {
    textAlign: "center",
    marginTop: "25px",
  },
  submitButton: {
    padding: "16px 24px",
    border: "none",
    backgroundColor: "#014c75",
    color: "white",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "1rem",
    fontWeight: "600",
    transition: "all 0.3s ease",
    boxShadow: "0 4px 12px rgba(1, 76, 117, 0.3)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    width: "100%",
    minHeight: "54px",
  },
  submitButtonDisabled: {
    padding: "16px 24px",
    border: "none",
    backgroundColor: "#95a5a6",
    color: "white",
    borderRadius: "8px",
    cursor: "not-allowed",
    fontSize: "1rem",
    fontWeight: "600",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    width: "100%",
    minHeight: "54px",
  },
  spinner: {
    width: "16px",
    height: "16px",
    border: "2px solid transparent",
    borderTop: "2px solid white",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
  },
  requiredNote: {
    fontSize: "0.8rem",
    color: "#666",
    marginTop: "12px",
    fontStyle: "italic",
  },
};

export default AddMember;